export default __webpack_public_path__ + "static/media/direct-healthcare-logo.d50a40b1.svg";